export const ACTIONS = {
    UPDATE_KEYWORD: "update_keyword",
    UPDATE_RATING: "update_rating",
};